import React, { useEffect } from 'react';
import './WhyFynessGlobal.css';

const WhyFynessGlobal = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const stats = [
    { number: '200,000+', label: 'Active Clients Worldwide' },
    { number: '$2.05T', label: 'Trading Volume (October 2025)' },
    { number: '4.8/5', label: 'Rating on Trustpilot' },
    { number: '3.6M', label: 'Trades Per Day' }
  ];

  const features = [
    { icon: '⚡', title: 'Fast Execution', desc: 'Orders executed in under 40ms' },
    { icon: '💰', title: 'Competitive Pricing', desc: 'Spreads from 0.0 pips' },
    { icon: '🛡️', title: 'Regulated & Secure', desc: 'Client funds in segregated accounts' },
    { icon: '📱', title: '24/7 Support', desc: 'Multilingual customer support' },
    { icon: '🌐', title: '2000+ Instruments', desc: 'Forex, Stocks, Commodities, Crypto' },
    { icon: '📊', title: 'Advanced Platforms', desc: 'MT4, MT5, TradingView, cTrader' }
  ];

  return (
    <div className="page-container">
      <div className="container">
        <button className="back-button" onClick={() => window.history.back()}>
          <span>←</span><span>Back to Home</span>
        </button>

        <h1>Why Choose BGI Assets</h1>
        <p className="subtitle">Experience the difference with a broker built by traders, for traders.</p>

        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="stat-number">{stat.number}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyFynessGlobal;